import { render, staticRenderFns } from "./packageName.vue?vue&type=template&id=db667062&scoped=true"
import script from "./packageName.vue?vue&type=script&lang=js"
export * from "./packageName.vue?vue&type=script&lang=js"
import style0 from "./packageName.vue?vue&type=style&index=0&id=db667062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db667062",
  null
  
)

export default component.exports